import React, { useEffect, useState } from "react";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import PerfilService from "../../services/PerfilService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { GlobeAltIcon } from "@heroicons/react/24/solid";

const UserBasicData = () => {

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({} as any);
  const { id }: any = useParams();

  const getUser = async () => {
    await PerfilService
      .getUserById(id)
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  useEffect(() => {
    getUser();
  }, []);
  
  return (
    <Layout user={user}>
      <LayoutDashboard>
        <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6 h-full">

            <div className="text-neutral-500 font-bold">
              Local:
            </div>

            <div className="mt-8 ms-3">

              <div className="grid grid-cols-1 md:grid-cols-3 gap-1 w-100">
                  <div className="flex w-100 md:w-1/3">
                    <div className="text-neutral-700 font-semibold ms-2">
                      {'País: '}
                    </div>
                    <div className="text-neutral-700 ms-2">
                      {user.address?.country ?? " - "}
                    </div>
                  </div>
                  <div className="flex w-100 md:w-1/3">
                    <div className="text-neutral-700 font-semibold ms-2">
                      {'Estado: '}
                    </div>
                    <div className="text-neutral-700 ms-2">
                      {user.address?.state ?? " - "}
                    </div>
                  </div>
                  <div className="flex w-100 md:w-1/3">
                    <div className="text-neutral-700 font-semibold ms-2">
                      {'Cidade: '}
                    </div>
                    {/* nao quebrar a linha */}
                    <div className="text-neutral-700 ms-2 whitespace-nowrap">
                      {user.address?.city ?? " - "}
                    </div>
                  </div>
              </div>
            </div>

            <hr className="mt-4" />

            <div className="text-neutral-500 font-bold mt-8">
              Dados Profissionais:
            </div>

            <div className="mt-8 ms-3">
          
              <div className="flex mt-4">
                <div className="text-neutral-700 font-semibold ms-2">
                  {'Empresa: '}
                </div>
                <span className="text-neutral-700 dark:text-neutral-300 truncate ms-2">
                  {user.company?.companyName ?? " - "}
                </span>
              </div>

              <div className="flex mt-4">
                <div className="text-neutral-700 font-semibold ms-2">
                  {'Site: '}
                </div>
                <span className="text-neutral-700 dark:text-neutral-300 truncate ms-2">
                  {user.company?.website ?? " - "}
                </span>
              </div>

              <div className="flex mt-4">
                <div className="text-neutral-700 font-semibold ms-2">
                  {'Ramo: '}
                </div>
                <span className="text-neutral-700 dark:text-neutral-300 truncate ms-2">
                  {user.company?.activity ?? " - "}
                </span>
              </div>

              <div className="flex mt-4">
                <div className="text-neutral-700 font-semibold ms-2">
                  {'Cargo: '}
                </div>
                <span className="text-neutral-700 dark:text-neutral-300 truncate ms-2">
                  {user.company?.position ?? " - "}
                </span>
              </div>
            </div>

        </div>
      </LayoutDashboard>
    </Layout>
  );
};

export default UserBasicData;
